import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatomoRestService} from '../../../core/services/api/matomo.rest-service';
import {map, startWith, takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AdsRestService} from '../../../core/services/api/cms/ads.rest-service';
import {BlobRestService} from '../../../core/services/api/blob.rest-service';
import {MarketingService} from '../../../core/services/marketing.service';
import {jsPDF} from 'jspdf';
import * as htmlToImage from 'html-to-image';
import {MatTabGroup} from '@angular/material/tabs';
import * as CryptoJS from 'crypto-js';
import {VendorsService} from '../../../core/services/vendors.service';
import {AccountService} from '../../../core/services/account.service';
import {MatomoService} from '../../../core/services/matomo.service';


@Component({
    selector: 'phx-supplier-report',
    templateUrl: './supplier-report.component.html',
    styleUrls: ['./supplier-report.component.scss'],
    standalone: false
})
export class SupplierReportComponent implements OnInit, OnDestroy {
    private ngUnsubscribe$ = new Subject<void>(); // emit unsubscription
    @ViewChild('tabs', {static: false}) tabs: MatTabGroup;
    public dataForm: FormGroup;
    public compareForm: FormGroup;

    ads = [];
    adsForDate = [];
    options = {};
    loadingAds = true;
    click: number = 0;
    view: number = 0;
    group: number = 1;
    adCompare = [];
    slideCompare = [];
    advertCompare = [];

    private impressions: any;

    selectedSlides: { slide: any, compares: any[] }[] = [];
    selectedAds: { ad: any, compares: any[] }[] = [];
    selectedAdvert: any = null;

    canSelect = true;

    sliders = [];
    adverts = [];
    loadingSliders = true;
    selectedDialog: any;
    pdf;
    added = false;
    vendors = [];
    filteredOptions: Observable<string[]>;
    vendorFilter = new FormControl();
    locations: any = [
        {value: 'DASH', label: 'Super Banner'},
        {value: 'RIGHT', label: 'Rechts Skyscraper Banner'},
        {value: 'LEFT', label: 'Links Skyscraper Banner'},
        {value: 'MENU', label: 'Square Banner'},
        {value: 'PROMO', label: 'Promotions Banner'},
        {value: 'FEATURED_BANNER', label: 'Featured Banner'},
        {value: 'INVOICE_BANNER', label: 'Belegsuche Footer Banner'},
        {value: 'PRODUCT_SEARCH', label: 'Product Search Banner'},
    ];
    idfs = 0;
    protected currentAd: any;
    private allAds = [];
    adCalculate: any = false;
    currentSlide: any;
    slideCalculate = false;

    displayFn(vendor: any): string {
        return vendor && vendor.name ? vendor.name : '';
    }

    constructor(private matomoRestService: MatomoRestService,
                private matomoService: MatomoService,
                private adsService: AdsRestService,
                private blobService: BlobRestService,
                private marketingService: MarketingService,
                private formBuilder: FormBuilder,
                private elementRef: ElementRef,
                private vendorsService: VendorsService,
                private accountService: AccountService,
                @Inject('CDN') public CDN) {
        this.dataForm = this.formBuilder.group({
            selectedAds: [''],
            selectedSlide: [''],
            selectedAdvertorial: ['']
        });

        this.compareForm = this.formBuilder.group({
            compareAds: [''],
            compareSlide: [''],
            compareAdvertorial: ['']
        });
        this.vendorsService.loadAllVendors().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(ven => {
            this.vendors = ven;
        });

        this.accountService.countAccounts().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(count => {
            this.idfs = count.returnObject;
        });

        this.pdf = new jsPDF();
    }

    ngOnInit() {
        this.filteredOptions = this.vendorFilter.valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value.name),
                map(name => name ? this._filter(name) : this.vendors.slice())
            );
    }

    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();

        return this.vendors.filter(option => option.name.toLowerCase().includes(filterValue));
    }


    addToFile(part) {
        this.added = true;
        let collection;
        let i = 1;
        let y = 10;

        this.pdf.addImage('/assets/img/apothekenportal_icon_text_gruen_filled.png', 'png', this.pdf.internal.pageSize.getWidth() - 55, y - 5);
        this.pdf.setFont('helvetica', 'normal', 400);

        const pageWidth = this.pdf.internal.pageSize.width || this.pdf.internal.pageSize.getWidth();

        const baseFontSize = 10;
        const h2FontSize = 20;


        switch (part) {
            case 'ads':
                collection = (document).getElementsByClassName('performance-ad');
                break;
            case 'slides':
                collection = (document).getElementsByClassName('performance-slide');
                break;
            default:
                break;
        }

        console.log(this.pdf.getCurrentPageInfo().pageNumber);

        for (let item of collection) {
            let el = new ElementRef(item);
            let selected;

            let id = el.nativeElement.id;
            let click = el.nativeElement.dataset.click;
            let elType = el.nativeElement.dataset.type;
            let group = 0;
            let view = 0;
            let viewPerc = 0;
            const font = 'helvetica';

            if (part === 'ads') {
                group = el.nativeElement.dataset.group;
                view = el.nativeElement.dataset.view;
                viewPerc = el.nativeElement.dataset.viewPerc;

                selected = this.selectedAds.find(a => {
                    return a.ad.id === parseInt(id);
                });
            }

            if (part === 'slides') {
                selected = this.selectedSlides.find(s => {
                    return id === CryptoJS.HmacSHA256(s.slide.title + s.slide.start + s.slide.end, 'slide').toString(CryptoJS.enc.Base64);
                });
            }

            if (selected) {
                htmlToImage.toPng(item)
                    .then((dataUrl) => {
                        y += 20;
                        this.pdf.setFont(font, 'normal', 400);
                        this.pdf.setFontSize(h2FontSize);
                        this.pdf.setTextColor(0, 151, 117);
                        this.pdf.text((selected.ad.title).toUpperCase(), 10, y);
                        y += 3;
                        this.pdf.setFillColor(0, 151, 117);
                        this.pdf.line(10, y, this.pdf.internal.pageSize.getWidth() - 10, y, 'F');

                        y += 3;
                        this.pdf.setFillColor(242, 242, 242);
                        this.pdf.rect(70, y + 7, this.pdf.internal.pageSize.getWidth() - 80, 80, 'F');

                        const img = this.CDN + '/marketing-management/' + selected.ad.image;
                        const imgProp = this.pdf.getImageProperties(this.CDN + '/marketing-management/' + selected.ad.image);

                        const rat = imgProp.height / imgProp.width;
                        if (part === 'ads') {
                            if (selected.ad.location === 'DASH') {
                                this.pdf.addImage(img, imgProp.fileType, 70, y + 7, this.pdf.internal.pageSize.getWidth() - 80, (this.pdf.internal.pageSize.getWidth() - 80) * rat);
                            } else {
                                let x = 70;
                                if (selected.ad.location === 'RIGHT') {
                                    x = this.pdf.internal.pageSize.getWidth() - (80 / rat) - 10;
                                }
                                this.pdf.addImage(img, imgProp.fileType, x, y + 7, 80 / rat, 80);
                            }
                        } else {
                            this.pdf.addImage(img, imgProp.fileType, 70, y + 7, this.pdf.internal.pageSize.getWidth() - 80, (this.pdf.internal.pageSize.getWidth() - 80) * rat);
                        }

                        y += 25;

                        y = this.matomoService.addAdFormat(y, baseFontSize, font, selected.ad, this.pdf, elType);

                        y += 35;

                        this.pdf.setFontSize(h2FontSize);
                        this.pdf.setTextColor(0, 151, 117);
                        this.pdf.text('PERFORMANCE', 10, y);
                        this.pdf.setFillColor(0, 151, 117);
                        this.pdf.line(10, y + 3, this.pdf.internal.pageSize.getWidth() - 10, y + 3, 'F');
                        y += 6;
                        const ratio = el.nativeElement.clientHeight / el.nativeElement.clientWidth;

                        this.pdf.addImage(dataUrl, 'png', 10, y, pageWidth - 20, (pageWidth - 20) * ratio);

                        y += 80;
                        this.pdf.setFontSize(h2FontSize);
                        this.pdf.setTextColor(0, 151, 117);
                        this.pdf.text('INTERPRETATION', 10, y);
                        this.pdf.setFillColor(0, 151, 117);
                        this.pdf.line(10, y + 3, this.pdf.internal.pageSize.getWidth() - 10, y + 3, 'F');
                        this.pdf.setFontSize(baseFontSize);
                        this.pdf.setTextColor(0);

                        y += 10;

                        const clickPerf = this.matomoService.clickPerformance(click);
                        let text = 'Ihre ' + elType + ' Buchung zu „' + selected.ad.title + '“ generierte in der relevanten Zielgruppe eine ' + clickPerf + ' Clickperformance. ';

                        if (group > 0) {
                            text += 'Es wurde eine Zielgruppeabdeckung von ' + group * 100 + '% im Buchungszeitraum erreicht. ';
                        }

                        if (view > 0) {
                            const viewPerf = this.matomoService.viewPerformance(viewPerc);
                            text += 'Es wurde eine ' + viewPerf + ' Sichtbarkeit von ' + view + ' im Buchungszeitraum erreicht.';
                        }

                        this.pdf.text(text, 10, y, {maxWidth: this.pdf.internal.pageSize.getWidth() - 20});

                        this.addFooter(this.pdf, elType);
                        this.pdf.setTextColor(0);

                        y = 10;

                        if (this.pdf.getCurrentPageInfo().pageNumber !== collection.length) {
                            this.pdf.addPage();
                        }
                    });
            }
        }
    }

    exportPdf() {
        this.pdf.save('hersteller-report.pdf');
        this.added = false;
        this.pdf = new jsPDF();
    }

    addFooter(doc, type) {
        let y = doc.internal.pageSize.getHeight() - (8 * 5);
        doc.setFillColor('#999999');
        doc.line(10, y - 3, doc.internal.pageSize.getWidth() - 10, y - 3, 'F');

        y += 2;
        doc.setFontSize(8);
        doc.setTextColor('#999999');
        doc.text('Die ' + type + ' Performance wird anhand eines Benchmarkings ausgerichtet. Dieses beziecht sich auf vergleichbare ' + type + ' Buchungen im Apothekenportal in \r\neinem Referenzzeitraum', 10, y);
        y += 8;
        doc.setFont('helvetica', 'normal', 700);
        doc.text('Click-Performance', 10, y);
        doc.setFont('helvetica', 'normal', 400);
        let dimensions = doc.getTextDimensions('Click-Performance');
        doc.text(' Beschreibt das Verhältnis von Klicks auf Tagesbasis unter Berücksichtigung der Selektionsgüte.', dimensions.w * 1.5, y);

        y += 8;
        doc.setFont('helvetica', 'normal', 700);
        doc.text('Zielgruppenabdeckung', 10, y);
        doc.setFont('helvetica', 'normal', 400);
        dimensions = doc.getTextDimensions('Zielgruppenabdeckung');
        doc.text(' Gibt an, wie viel % der Targeting-Menge im Buchungszeitraum den Banner mind. einmal gesehen haben.', dimensions.w * 1.5, y);

        y += 8;
        doc.setFont('helvetica', 'normal', 700);
        doc.text('Sichtbarkeit', 10, y);
        doc.setFont('helvetica', 'normal', 400);
        dimensions = doc.getTextDimensions('Sichtbarkeit');
        doc.text(' Gibt an, wie häufig die Nutzer der Zielgruppe das Medium innerhalb des Buchungszeitraum gesehen haben.', dimensions.w * 2, y);
    }

    selectVendor($event: any) {
        const vendor = $event;
        console.log('selecting vendor');
        console.log(vendor);

        this.adsService.getSupplierAds('', vendor).subscribe(ad => {
            this.adsForDate = ad.return_object;
            this.allAds = ad.return_object;
            this.loadingAds = false;
        });

        this.marketingService.downloadList('slider').then(value => {
            console.log(value);
            this.sliders = value.filter(slide => slide.vendor === vendor);

            this.loadingSliders = false;
        });
    }

    selectingVendor(event) {
        var name = event.target.value;
        var selected = this.vendors.filter(option => option.name === name);

        if (selected.length === 1) {
            this.selectVendor(selected[0].id);
        }
    }

    getLocation(location: string) {
        return this.locations.find(loc => loc.value === location).label;
    }

    selectAd() {
        this.canSelect = false;
        const values = this.dataForm.value;
        this.currentAd = values['selectedAds'];
        const selected = this.adsForDate.find(ad => this.currentAd === ad.id);

        this.adsForDate = this.adsForDate.filter(ad => ad.id !== selected.id);

        selected['parallel'] = this.matomoService.getParallelAds(selected, this.allAds);
        this.selectedAds.push({ad: selected, compares: []});

        if (selected.idfs.length > 0) {
            this.adsForDate = this.adsForDate.filter(ad => ad.idfs.length > 0);
        } else {
            this.adsForDate = this.adsForDate.filter(ad => ad.idfs.length === 0);
        }
    }

    selectCompare(ad) {
        console.log(ad);
        let compares = this.selectedAds.findIndex(sel => sel.ad.id === ad);
        const values = this.dataForm.value;

        this.selectedAds[compares].compares.push(this.adsForDate.find(ad => values['selectedAds'] === ad.id));
        console.log(this.selectedAds);
    }

    addNewAd() {
        this.canSelect = true;
    }

    deleteCompare(i, j) {
        this.selectedAds[i].compares.splice(j, 1);
    }

    selectSlide() {
        const values = this.dataForm.value;
        this.currentSlide = values['selectedSlide'];
        if(this.currentSlide) {
            const selected = this.sliders.find(slide => this.currentSlide === (slide.title+'-'+slide.start+'-'+slide.end));
            selected['id'] = this.currentSlide;

            this.selectedSlides.push({slide: selected, compares: []});
        }
    }

    selectCompareSlide(slideId: any) {
        let compIndex = this.selectedSlides.findIndex(slide => slide.slide['id'] === slideId);
        const values = this.dataForm.value;

        this.selectedSlides[compIndex].compares.push(this.sliders.find(slide => values['selectedSlide'] === slide.title+'-'+slide.start+'-'+slide.end))
        console.log(this.selectedSlides);
    }

    /**
     * unsubcribe all subscriptions on destroy
     */
    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    addNewSlide() {

    }
}
